import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, of, Subject, takeUntil } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { OtherService } from 'src/app/services/other.service';

@Component({

  selector: 'app-specialist-verification',

  templateUrl: './specialist-verification.component.html',

  styleUrls: ['./specialist-verification.component.css']

})

export class SpecialistVerificationComponent {

  @ViewChild('detailsDialogTemplate') detailsDialogTemplate: TemplateRef<any>;

  isSubmitDisabled = false;

  strMobile = '';

  tankerProfile = null;

  unSubscribeAll$ = new Subject<void>();

  constructor(
    private accountService: AccountService,
    private otherService: OtherService,
    private ngbModal: NgbModal,
    private router: Router,
  ) { }

  submit(strMobileField: NgModel) {
    if (strMobileField.invalid || strMobileField.pristine || this.isSubmitDisabled) {
      return;
    }
    this.isSubmitDisabled = true;
    this.tankerProfile = null;

    const model = {
      strMobile: this.strMobile,
      iSystemUser: this.otherService.specialistUser.iSystemUser,
      strSession: this.otherService.specialistUser.strSession
    };

    this.accountService.specialistCheckMobile(model).pipe(
      catchError(() => of(false)),
      takeUntil(this.unSubscribeAll$),
    ).subscribe((response: string | false) => {
      this.isSubmitDisabled = false;

      if (response) {
        let result = JSON.parse(response);
        result = result[0];

        if (!result) {
          this.router.navigate(['/specialist-registration'], { queryParams: { mobile: this.strMobile } });
          return;
        }
        if (result.iResult === 0) {
          return this.accountService.toastSwal('error', result.strError);
        }

        this.tankerProfile = result;
        this.openDetailsDialog();
        this.accountService.toastSwal('success', `عملیات با موفقیت انجام شد`);
      } else {
        this.accountService.toastSwal('error', 'خطایی رخ داد');
      }
    });
  }

  openDetailsDialog(): void {
    this.ngbModal.open(this.detailsDialogTemplate, { scrollable: true, container: 'app-specialist-verification', modalDialogClass: 'details-dialog', centered: true, animation: false });
  }

  unSubscribeAll(): void {
    this.unSubscribeAll$.next();
    this.unSubscribeAll$.complete();
  }

  ngOnDestroy(): void {
    this.unSubscribeAll();
  }

}